module.exports = __webpack_public_path__ + "static/images/cd02.eb2fb74.png";